import React, { useState, useEffect } from 'react'
import { createMuiTheme, ThemeProvider, responsiveFontSizes } from '@material-ui/core/styles';
import { useConfig } from '../config/use'


export const MaterialThemeProvider = ({children}) => {
  const { state: {loadedpalette, palette}, actions: {GetPalette} } = useConfig();
  const [theme, setTheme] = useState(createMuiTheme({
    palette: {
      primary: {
        main: "#fff",
      },
      secondary: {
        main: "#fff"
      },
      tertiary: {
        main: "#fff"
      },
      button_text: {
        main: "#fff"
      },
      secondary_text: {
        main: "#fff"
      },
      footer_color: {
        main: "#fff"
      },
      menu: {
        main: "#fff"
      },
      background: {
        main: "#fff"
      },
      ticket_waiting: {
        main: "#fff"
      },
      ticket_called: {
        main: "#fff"
      },
      ticket_cancelled: {
        main: "#fff"
      },
      listitem: {
        main: "#fff"
      },
      error: {
        main: "#fff"
      },
      warning: {
        main: "#fff"
      },
      info: {
        main: "#fff"
      },
      success: {
        main: "#fff"
      },
      loadingbar_front: {
        main: "#fff"
      },
      loadingbar_back: {
        main: "#fff"
      }
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 640,
        md: 960, 
        lg: 1280,
        xl: 1920,
        xxl: 2000
      }
    }
  }));

  useEffect(() => {
    if (loadedpalette)
    {
      var newtheme = createMuiTheme({
        palette: {
          primary: {
            main: palette ? palette.primary : "#000",
          },
          secondary: {
            main: palette ? palette.secondary : "#000",
          },
          tertiary: {
            main: palette ? palette.tertiary : "#000"
          },
          button_text: {
            main: palette ? palette.button_text : "#000"
          },
          secondary_text: {
            main: palette ? palette.secondary_text : "#000"
          },
          footer_color: {
            main: palette ? palette.footer_text : "#000"
          },
          menu: {
            main: palette ? palette.menu : "#000"
          },
          background: {
            main: palette ? palette.background : "#000"
          },
          ticket_waiting: {
            main: palette ? palette.ticket_waiting : "#000"
          },
          ticket_called: {
            main: palette ? palette.ticket_called : "#000"
          },
          ticket_cancelled: {
            main: palette ? palette.ticket_cancelled : "#000"
          },
          listitem: {
            main: palette ? palette.listitem : "#000"
          },
          error: {
            main: palette ? palette.error : "#000"
          },
          warning: {
            main: palette ? palette.warning : "#000"
          },
          info: {
            main: palette ? palette.info : "#000"
          },
          success: {
            main: palette ? palette.success : "#000"
          },
          loadingbar_front: {
            main: palette ? palette.loadingbar_front : "#000"
          },
          loadingbar_back: {
            main: palette ? palette.loadingbar_back : "#000"
          }
        },
        breakpoints: {
          values: {
            xs: 0,
            sm: 640,
            md: 960, 
            lg: 1280,
            xl: 1920,
            xxl: 2000
          }
        }
      });

      setTheme(responsiveFontSizes(newtheme))
    }
    else
      GetPalette()
  },[loadedpalette])

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  )
}